import DOMPurify from "dompurify";

const CONFIG = {
  ALLOWED_TAGS: [
    "p", "br", "strong", "em", "b", "i", "u",
    "ul", "ol", "li",
    "h2", "h3",
    "a", "blockquote", "code", "pre", "hr",
  ],
  ALLOWED_ATTR: ["href", "target", "rel"],
};

export default function RichTextView({ html, className = "" }) {
  const dirty = html || "";
  // If the stored body is plain text (no HTML tags), render with line-breaks preserved
  const looksLikeHtml = /<[a-z][\s\S]*>/i.test(dirty);
  if (!looksLikeHtml) {
    return (
      <div className={`rich-content whitespace-pre-wrap ${className}`}>{dirty}</div>
    );
  }
  const clean = DOMPurify.sanitize(dirty, CONFIG);
  return (
    <div
      className={`rich-content ${className}`}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}

export function stripHtml(html) {
  if (!html) return "";
  const tmp = (html || "").replace(/<[^>]*>/g, " ").replace(/&nbsp;/g, " ").replace(/\s+/g, " ").trim();
  return tmp;
}
